import React, { useState, useEffect } from 'react';
import StepRadioButton from './StepRadioButton';
import ColorSelector from './ColorSelector';
import AlertMessage from './AlertMessage';
import { useSelector, useDispatch } from 'react-redux';
import {
    setForceTreatmentType,
    closeLearnMoreModal,
    cleanForceTreatmentType,
    setEditColorLens,
    setStepValueSelected,
    setGoToTreatment,
    setSelectedColorOption,
    setProductImage,
    setProductImageOld,
    setImageErrorMessage,
    setLensErrorMessage,
} from '../app/mainSlice';
import Slider from 'react-slick';

/**
 * @param props.key
 * @param props.id
 * @param props.className
 * @param props.group
 * @param props.options
 * @param props.handleChange
 * @param props.handleAddColor
 * @param props.isLearnMore
 */
const StepRadioGroup = props => {
    const dispatch = useDispatch();
    const forceTreatmentType = useSelector(state => state.main.forceTreatmentType);
    const selectedWarranty = useSelector(state => state.main.selectedWarranty);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const treatmentOptions = useSelector(state => state.main.treatmentOptions);
    const totalPrice = useSelector(state => state.main.totalPrice);
    const [selectedOptionKey, setSelectedOptionKey] = useState(null);
    const [selectedOptionId, setSelectedOptionId] = useState(null);
    const blueLightAlertContent = useSelector(state => state.main.blueLightAlertContent);
    const blueLightGamingAlertContent = useSelector(
        state => state.main.blueLightGamingAlertContent
    );
    const mirrorAlertContent = useSelector(state => state.main.mirrorAlertContent);
    const productImageOld = useSelector(state => state.main.productImageOld);
    const productImage = useSelector(state => state.main.productImage);
    const isGVP = useSelector(state => state.main.isGVP);

    useEffect(() => {
        if (selectedOptionKey == null && props.options.length > 0) {
            setSelectedOptionKey(props.options[0].key);
        }
    }, []);

    useEffect(() => {
        if (treatmentOptions == null && !props.isLearnMore) {
            setSelectedOptionId(null);
        } else if (treatmentOptions !== null && selectedOptionKey) {
            let currentOptionId = treatmentOptions[selectedOptionKey];

            if (currentOptionId && selectedOptionId !== currentOptionId) {
                setSelectedOptionId(null);
            }
        }
    }, [treatmentOptions, totalPrice]);

    const handleChange = (optionKey, optionId, optionPackage, optionColorOptions) => evt => {
        evt.preventDefault();
        evt.currentTarget.blur();

        if (!props.isLearnMore) {
            // Standard case
            setSelectedOptionId(selectedOptionId == optionId ? null : optionId);

            if (props.handleChange && typeof props.handleChange == 'function') {
                props.handleChange(
                    optionKey,
                    selectedOptionId == optionId ? null : optionId,
                    optionPackage ? optionPackage : null
                );
            }
        } else {
            // Not change if equal
            if (selectedOptionId !== optionId) {
                setSelectedOptionId(optionId);

                if (props.handleChange && typeof props.handleChange == 'function') {
                    props.handleChange(optionKey, optionId, optionPackage ? optionPackage : null);
                }

                if (props.isLearnMore) {
                    dispatch(
                        setStepValueSelected({
                            [optionKey]: optionId,
                        })
                    );
                }
            }
        }

        if (
            ((isGVP && props.group == 'treatment') ||
                props.group === 'transition' ||
                props.group == 'colorCategory') &&
            !isLearnMoreModalOpen
        ) {
            dispatch(setSelectedColorOption(null));
            dispatch(
                setEditColorLens(
                    selectedOptionId == optionId ||
                        !optionColorOptions ||
                        optionColorOptions.length == 0
                        ? false
                        : true
                )
            );

            if (
                props.config.data.frame.category &&
                props.config.data.frame.category.toUpperCase() === 'SUNGLASSES' &&
                !isLearnMoreModalOpen
            ) {
                if (selectedOptionId == optionId) {
                    dispatch(setProductImage(productImageOld));
                    dispatch(setProductImageOld(null));
                    dispatch(setImageErrorMessage(false));
                    dispatch(setLensErrorMessage(false));
                } else {
                    if (productImageOld === null) dispatch(setProductImageOld(productImage));
                }
            }
        }

        if (props.group === 'blueLight' && !isLearnMoreModalOpen) {
            dispatch(setSelectedColorOption(null));
            dispatch(setEditColorLens(false));
        }
    };

    const handleChangeAdd = (optionKey, optionId, optionPackage) => {
        setSelectedOptionId(optionId);

        if (props.handleChange && typeof props.handleChange == 'function') {
            props.handleChange(optionKey, optionId, optionPackage);
        }

        if (
            ((isGVP && props.group == 'treatment') ||
                props.group === 'transition' ||
                props.group == 'colorCategory') &&
            !isLearnMoreModalOpen
        ) {
            dispatch(setEditColorLens(true));

            if (
                props.config.data.frame.category &&
                props.config.data.frame.category.toUpperCase() === 'SUNGLASSES' &&
                !isLearnMoreModalOpen
            ) {
                dispatch(setSelectedColorOption(null));
                if (!(selectedOptionId == optionId)) {
                    if (productImageOld === null) dispatch(setProductImageOld(productImage));
                }
            }
        }
    };

    useEffect(() => {
        if (
            props.group &&
            forceTreatmentType &&
            forceTreatmentType[props.group] &&
            !props.isLearnMore
        ) {
            handleChangeAdd(
                forceTreatmentType[props.group].optionKey,
                forceTreatmentType[props.group].optionId,
                forceTreatmentType[props.group].optionPackage
            );
            dispatch(cleanForceTreatmentType());
        }
    }, [forceTreatmentType]);

    const handleAddButton = (optionKey, optionId, optionPackage) => {
        dispatch(
            setForceTreatmentType({
                [props.group]: {
                    optionKey: optionKey,
                    optionId: optionId,
                    optionPackage: optionPackage,
                },
            })
        );
        dispatch(closeLearnMoreModal());
        dispatch(setGoToTreatment({ [props.group]: optionId }));
    };
    let i = 0;

    //Handles steps tabIndex order
    const getStepTabIndex = index => {
        return index === 1 ? '1' : (index + index - 1).toString();
    };

    const renderRadioGroup = (option, i) => {
        return (
            <>
                <StepRadioButton
                    key={option.id}
                    id={option.id}
                    tabIndex={
                        props.isLearnMore ? getStepTabIndex(i) : isLearnMoreModalOpen ? '-1' : '0'
                    }
                    title={option.title}
                    price={option.price}
                    description={option.description}
                    imageFileName={option.imageFileName}
                    imageAlt={option.imageAlt}
                    discount={option.discount}
                    dataAnalyticsAvailableCall={props.dataAnalyticsAvailableCall}
                    isSelected={
                        (selectedOptionId !== null && selectedOptionId == option.id) ||
                        (option.included && !props.isLearnMore) ||
                        (selectedWarranty && selectedWarranty.id == option.id)
                    }
                    handleChange={handleChange(
                        option.key,
                        option.id,
                        option.package,
                        option.colorOptions
                    )}
                    isDisabled={
                        isInsuranceLoading ||
                        (option.included && option.disabled && !props.isLearnMore)
                            ? true
                            : null
                    }
                    isIncluded={option.included}
                    isAlreadyIncluded={option.alreadyIncluded}
                    isWarranty={props.isWarranty}
                    isLearnMore={props.isLearnMore}
                    handleAddButton={() => {
                        handleAddButton(option.key, option.id, option.package, option.colorOptions);
                    }}
                    isInsuranceEnabled={isInsuranceEnabled}
                    isInsuranceLoading={isInsuranceLoading}
                    firstLearnMoreTreatment={
                        props.isLearnMore ? props.firstLearnMoreTreatment[i] : null
                    }
                    group={props.group}
                    colorLearnMoreOptions={option.colorLearnMoreOptions}
                    visibleColorCategories={option.visibleColorCategories}
                />
                {option.isLensGaming &&
                selectedOptionId !== null &&
                selectedOptionId == option.id &&
                blueLightGamingAlertContent ? (
                    <>
                        <AlertMessage message={blueLightGamingAlertContent} />
                    </>
                ) : null}
                {props.group == 'transition' &&
                selectedOptionId !== null &&
                selectedOptionId == option.id &&
                props.isBlueLightSelected &&
                blueLightAlertContent ? (
                    <>
                        <AlertMessage message={blueLightAlertContent} />
                    </>
                ) : null}
                {option.isMirror &&
                props.group == 'colorCategory' &&
                selectedOptionId !== null &&
                selectedOptionId == option.id &&
                mirrorAlertContent ? (
                    <>
                        <AlertMessage message={mirrorAlertContent} />
                    </>
                ) : null}
            </>
        );
    };

    return (
        <div
            key={props.id + '-container'}
            className={'step-radio-group' + (props.className ? ' ' + props.className : '')}
        >
            {props.isMobile ? (
                <>
                    <Slider {...props.settings}>
                        {props.options
                            ? props.options.map(option => {
                                  i++;
                                  props.firstLearnMoreTreatment[i] = React.createRef();
                                  return renderRadioGroup(option, i);
                              })
                            : null}
                    </Slider>
                </>
            ) : props.options ? (
                props.options.map(option => {
                    i++;
                    if (props.isLearnMore) props.firstLearnMoreTreatment[i] = React.createRef();
                    return (
                        <>
                            {renderRadioGroup(option, i)}
                            {((isGVP && props.group === 'treatment') ||
                                props.group === 'transition' ||
                                props.group == 'colorCategory') &&
                            selectedOptionId !== null &&
                            selectedOptionId == option.id &&
                            option.colorOptions &&
                            option.colorOptions.length > 0 ? (
                                <>
                                    <ColorSelector
                                        config={props.config}
                                        group={props.group}
                                        colorOptions={option.colorOptions}
                                        handleAddColor={props.handleAddColor}
                                        isInsuranceLoading={isInsuranceLoading}
                                    />
                                </>
                            ) : null}
                        </>
                    );
                })
            ) : null}
        </div>
    );
};

export default StepRadioGroup;
